import { API_ENDPOINTS } from '../constants'
import ApiService from './apiService'
import http from './http'

export default {
  async check() {
    const url = ApiService.buildUrl(API_ENDPOINTS.users)
    let { data } = await http.post(url)

    return data
  },

  async load() {
    const url = ApiService.buildUrl(API_ENDPOINTS.me)
    let { data } = await http.get(url)

    return data
  },

  async loadTips() {
    const url = ApiService.buildUrl(API_ENDPOINTS.tips)
    let { data } = await http.get(url)

    return data
  },

  async newSession() {
    const url = ApiService.buildUrl(API_ENDPOINTS.newSession)
    let { data } = await http.get(url)

    return data
  },

  async checkCode(key) {
    const url = ApiService.buildUrl(API_ENDPOINTS.codeSession, { key })
    let { data } = await http.get(url)

    return data
  }
}
